import script from "./ProductBriefOverview.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductBriefOverview.vue?vue&type=script&setup=true&lang=ts"

import "./ProductBriefOverview.vue?vue&type=style&index=0&id=d72f5b4e&lang=scss"

const __exports__ = script;

export default __exports__